/**
 * @file src/_modulos/prenota/tabela/layouts/filters/QuickFilter.tsx
 * @description Componente simplificado de filtros rápidos
 *
 * Princípios aplicados:
 * - KISS: Lógica simples e direta
 * - SRP: Apenas renderiza filtros rápidos
 * - YAGNI: Remove funcionalidades não utilizadas
 */

"use client";

import { SmartSelect, Tooltiper } from "visuais";
import { useQuickFilters } from "@PN/tabela";

/**
 * Componente de filtros rápidos
 */
export function QuickFilter() {
  const { filterOptions, currentFilters, handlers, formatters } =
    useQuickFilters();

  return (
    <div className="flex flex-wrap items-center gap-3 min-w-0">
      {/* Filtro de Filial */}
      <div className="flex flex-col items-start gap-1 min-w-0">
        <Tooltiper
          content={formatters.getFilialTooltipContent(
            currentFilters.currentFilial
          )}
        >
          <SmartSelect
            multiple={true}
            value={currentFilters.currentFilial}
            onChange={handlers.handleFilialChange}
            options={filterOptions.filialOptions}
            placeholder="Todas as filiais"
            className="w-fit max-w-2xs overflow-hidden min-w-0"
          />
        </Tooltiper>
      </div>

      {/* Filtro de Status */}
      <div className="flex flex-col items-start gap-1 min-w-0">
        <Tooltiper
          content={formatters.getStatusTooltipContent(
            currentFilters.currentStatus
          )}
        >
          <SmartSelect
            multiple={true}
            value={currentFilters.currentStatus}
            onChange={handlers.handleStatusChange}
            options={filterOptions.statusOptions}
            placeholder="Todos os status"
            className="w-fit max-w-2xs overflow-hidden min-w-0"
          />
        </Tooltiper>
      </div>

      {/* Filtro de Tipo */}
      <div className="flex flex-col items-start gap-1 min-w-0">
        <Tooltiper
          content={formatters.getTipoTooltipContent(currentFilters.currentTipo)}
        >
          <SmartSelect
            multiple={true}
            value={currentFilters.currentTipo}
            onChange={handlers.handleTipoChange}
            options={filterOptions.tipoOptions}
            placeholder="Todos os tipos"
            className="w-fit max-w-2xs overflow-hidden min-w-0"
          />
        </Tooltiper>
      </div>
    </div>
  );
}
